<div class="sample-section">
    <question-yesno-buttons title="Yes/No buttons"></question-yesno-buttons>
</div>
<div class="sample-section">
    <question-options [options]="radio" title="Radio buttons"></question-options>
</div>
<div class="sample-section">
    <question-text title="Text input"></question-text>
</div>
<div class="sample-section">
    <question-number minValue="1" maxValue="3" title="Numeric input"></question-number>
</div>
<div class="sample-section">
    <question-multi-option [options]="multi" title="Checkboxes"></question-multi-option>
</div>